import React, { Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BellIcon, SearchIcon, LayoutGridIcon } from 'lucide-react';
export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  // Generate breadcrumbs from path
  const pathnames = location.pathname.split('/').filter(x => x);
  const formatPathName = (name: string) => {
    return name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6 z-10 sticky top-0" data-id="element-242">
      <div className="flex items-center" data-id="element-243">
        <nav className="flex" aria-label="Breadcrumb" data-id="element-244">
          <ol className="flex items-center space-x-2" data-id="element-245">
            <li data-id="element-246">
              <button onClick={() => navigate('/')} className="inline-flex items-center text-gray-500 hover:text-indigo-600 text-sm font-medium transition-colors" data-id="element-247">
                <LayoutGridIcon className="h-4 w-4 mr-1.5" data-id="element-248" />
                Home
              </button>
            </li>
            {pathnames.map((name, index) => {
            const isLast = index === pathnames.length - 1;
            return <Fragment key={name} data-id="element-249">
                  <li data-id="element-250">
                    <span className="text-gray-400 mx-2" data-id="element-251">/</span>
                  </li>
                  <li data-id="element-252">
                    <span className={`text-sm font-medium ${isLast ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-253">
                      {formatPathName(name)}
                    </span>
                  </li>
                </Fragment>;
          })}
          </ol>
        </nav>
      </div>

      <div className="flex items-center space-x-4" data-id="element-254">
        <div className="relative hidden md:block" data-id="element-255">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-256">
            <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-257" />
          </div>
          <input type="text" className="block w-64 pl-10 pr-3 py-2 border border-gray-300 rounded-full leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition-colors" placeholder="Global search..." data-id="element-258" />
        </div>

        <button className="p-2 text-gray-400 hover:text-gray-500 relative" data-id="element-259">
          <span className="sr-only" data-id="element-260">View notifications</span>
          <BellIcon className="h-6 w-6" aria-hidden="true" data-id="element-261" />
          <span className="absolute top-1 right-1 block h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white" data-id="element-262"></span>
        </button>
      </div>
    </header>;
}